var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-source-table-cell"},[_vm._v(" "+_vm._s(_vm.getSource)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }